import React from "react";

export const CONFIG = {
    getApartmentUrl: 'booking_engine_webservice/get_apartment_url',
    getActiveCalculationUrl: 'booking_engine_webservice/get_active_calculation_url',
    getActiveCalculation: 'booking_engine_webservice/get_active_calculation',
    getOrCreateCalculation: '/booking_engine_webservice/get_calculation',
    updateCalculationEndpoint: '/booking_engine_webservice/update_calculation',
    getAvailability: "/booking_engine_webservice/get_availability",
    syncAvailability: "syncAvailability/",
    createOrderEndpoint: '/booking_engine_webservice/create_order',
    clearCart: 'clear-cart',
    loginEndpoint: '/login',
    getUserDataEndpoint: '/getCurrentUserAddress',
    checkUserEndpoint: '/login',
    completeCartEndpoint: '/finishCalculation',
    createCartEndpoint: '/booking_engine_webservice/create_cart_and_calculation', // Not used...
    discountEndpoint: '/booking_engine_webservice/get_discount',
    removeDiscount: '/booking_engine_webservice/remove_discount',
    ratePlansImage: 'flaming.png',
    ratePlansDiscountClubImage: 'discount-club-flaming.svg',
    conditionsUrl: '/warunki-rezerwacji',
    privacyPolicyUrl: '/polityka-prywatnosci',
    changeUserPasswordUrl: '/change-password',
    YP_CLEANING_SUPPLEMENT_ID: '32877',
    YP_PENTHOUSE_CLEANING_SUPPLEMENT_ID: '86942',
    YP_HOUSE_CLEANING_SUPPLEMENT_ID: '145480',
    YP_ROOM_CLEANING_SUPPLEMENT_ID: '124158',
    YP_CLEANING_SUPPLEMENTS: ['32877', '86942', '145480', '124158', '173988'],
    YP_REQUIRED_SUPPLEMENTS: ['253577'],
    USER_PANEL_URL: '/profil/details',
    owlCarouselDefaults: {
        loop: false,
        items: 1,
        dots: false,
        stagePadding: 20,
        margin: 10
    },
    currentLangPL: 'current-lang-pl',
    currentLangDE: 'current-lang-de',
    form_register: {
        name: '',
        surname: '',
        email: '',
        repeat_email: '',
        company: '',
        street: '',
        city: '',
        postal_code: '',
        comments: ''
    },
    checkin_time: '15:00',
    checkout_time: '11:00',
    taxStay: 0.08,
    GoogleTagManager: 'AW-828095433',
    FOOD_SUPPLEMENTS_ID: 3,
}

export const paymentUrl = 'http://paymentUrlDUMMYWEBSITE.com'
